import { createStyles } from '@material-ui/core';

const estilos = createStyles({
  encabezadoAplicacion: {
    marginBottom: '.5em',
  },
});

export default estilos;
